/**
 * Who is allowed to use the dev impersonation tooling.
 *
 * On deployed environments where the widget is switched on (test only — the
 * backend hard-refuses in Production) impersonation requires the browser to
 * already hold a Natlink staff session. Signing in AS a member replaces that
 * session, so one Natlink login buys exactly one impersonation: switching to
 * another member means logging in as Natlink again first.
 *
 * Kept free of import.meta so it stays unit-testable; the env part of the gate
 * lives in @/api/devImpersonation.
 */

/** Staff email domains trusted to impersonate. Mirrors the backend handler. */
export const NATLINK_EMAIL_DOMAINS = ["@natlink.se", "@natlink.fi"] as const;

/**
 * Whether the given session email belongs to Natlink staff. Matches the domain
 * exactly (`@natlink.se`) and requires a local part, so look-alikes such as
 * `x@evil-natlink.se`, `x@natlink.se.evil.com` or a bare `@natlink.se` do not
 * qualify.
 */
export function isNatlinkStaffEmail(email: string | null | undefined): boolean {
  const normalized = email?.trim().toLowerCase() ?? "";
  if (!normalized) return false;
  return NATLINK_EMAIL_DOMAINS.some(
    (domain) => normalized.length > domain.length && normalized.endsWith(domain)
  );
}
